import styled from 'styled-components';

import Alert from '@r1-frontend/ui-react/components/Alert';
import { Cost } from '@r1-frontend/ui-react/components/costs';
import DiscountLabel from '@r1-frontend/ui-react/components/DiscountLabel/PercentDiscountLabel';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Separator } from '@r1-frontend/ui-react/components/Separator';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { H3, H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import ConnectionConditions from '~/src/components/ConnectionConditions/ConnectionConditions';
import { useConstructorAnalytics } from '~/src/features/tariffBuilder/analytics/hooks/useConstructorAnalytics';
import { TSummaryInfo } from '~/src/features/tariffBuilder/selectors/getSummaryInfo';

import { TwoInRow, TwoInRowWithExtraSpace } from '~/src/features/tariffBuilder/styled';

export const SummaryInfo = ({
    discount,
    total,
    discountValue,
    groups,
    alert,
    ...props
}: TSummaryInfo): JSX.Element => {

    const analytics = useConstructorAnalytics();

    const clickedOpenConnectionCostPopup = analytics.clickedOpenConnectionCostPopup.bind(analytics);

    return (
        <ListContainer $desktop={24} $mobile={16} $direction={'column'} $wrap={'nowrap'} {...props}>
            <H3 $withIndent={false}>Ваш тариф <DiscountLabel>{discount}</DiscountLabel></H3>
            <ListContainer $size={24} $direction={'column'} $wrap={'nowrap'}>
                {groups.map(group => (
                    <ListContainer $desktop={4} $mobile={16} key={group.header} $direction={'column'} $wrap={'nowrap'}>
                        <Paragraph4 as={TwoInRowWithExtraSpace} $color={COLORS.TextInfo}>{group.header} <Cost>{group.cost}</Cost></Paragraph4>
                        {group.items.length > 0 && (
                            <ListContainer $size={4} $direction={'column'} $wrap={'nowrap'}>
                                {group.items.map(item => (<>
                                    <Paragraph4 key={`${group.header}_${item.title}_${item.cost}`}>
                                        {item.title}
                                    </Paragraph4>
                                    {item.period && item.period > 1 && (
                                        <Paragraph4 $color={COLORS.TextInfo}>
                                            В рассрочку на {item.period} мес &mdash; <Cost isMonthly={true}>{item.cost}</Cost>
                                        </Paragraph4>
                                    )}
                                    {item.period && item.period === 1 && (
                                        <Paragraph4 $color={COLORS.TextInfo}>
                                            В собственность &mdash; <Cost>{item.cost}</Cost>
                                        </Paragraph4>
                                    )}
                                </>))}
                            </ListContainer>
                        )}
                        {group.header === 'Подключение' && (
                            <ConnectionConditions analyticsCallback={clickedOpenConnectionCostPopup}/>
                        )}
                    </ListContainer>
                ))}
            </ListContainer>

            <Separator $height={1.5}/>

            <div>
                <TwoInRow>
                    <H4 $inline={true}>Итого при подключении:</H4>
                    <H4 $inline={true} as={Cost}>{total}</H4>
                </TwoInRow>
                <TwoInRow>
                    <H4 $inline={true} $withIndent={false}>Скидка:</H4>
                    <H4 $inline={true} $withIndent={false} as={Cost}>{discountValue}</H4>
                </TwoInRow>
            </div>

            {alert && (
                <Alert type={'white'} Icon={InfoCircleFlip}>
                    <Paragraph4 dangerouslySetInnerHTML={{ __html: alert }} />
                </Alert>
            )}
        </ListContainer>
    );
};

export default styled(SummaryInfo)`
    width: 100%;
    height: 100%;

    & > ${H3} > div {
        margin-left: 8px;
    }

    & > ${ListContainer} {
        overflow: auto;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        & > ${H3} > div {
            margin-left: 8px;
        }
    }
`;
